import { useEffect, useState } from 'react'
import _ from 'lodash'
import { Button, Toast } from '@vzmi/shp_shared_compo'
import Tip from '../../../Common/Tip'
import {
  FormRow,
  MassiveMenuSelectField,
  When
} from '../../../../Common/Form'
import { Field } from '../../../../Common/forms'
import SingleLineText from '../../../Common/ReadOnlyComponents/SingleLineText/SingleLineText'
import { safeAwait, httpHandler } from '@vzmi/component_ec_nodejs_util/dist/lib/FetchDataUtil'
import styles from './index.css'
import { getNoticeAndBrandIdForSpec } from '../../../UpdateListingInfo/helper'
import { getSpecAttributeFullField } from '../../../Common/ProposalForm/Shared/util'
const brandIdConnectField = 'product.brandId'
const brandNameConnectField = 'product.brandName'

const BrandIDInfo = props => {
  const {
    readOnly,
    fetchBrands,
    triggerFieldChange,
    showErrorOnActive,
    mustShowFormError,
    listing
  } = props
  const [options, setOptions] = useState([])

  // load brand options on mount
  useEffect(() => {
    if (!readOnly) {
      const fetchData = async () => {
        const [error, payload] = await safeAwait(
          fetchBrands().then(httpHandler)
        )
        if (error) {
          Toast.error('無法取得商品品牌列表，請重新整理頁面')
          return
        }
        // make every item in the array an object with value and label replaced with name and id
        const brands = _.get(payload, 'brands', [])
        setOptions(brands.map(brand => ({
          value: brand.id,
          label: brand.name
        })))
      }
      fetchData()
    }
  }
  , [fetchBrands, readOnly])

  const alginWithSpecTable = () => {
    const product = _.get(listing, 'product', '')
    const subStationId = _.get(listing, 'subStationId', '')
    const catItemId = _.get(product, 'catItemId', '')
    const struDataAttrClusterId = _.get(product, 'struDataAttrClusterId', '')
    const hasLevel = !_.isEmpty(_.get(listing, 'product.specs', ''))
    const transientSpecTableKey = getSpecAttributeFullField(
      subStationId,
      catItemId,
      struDataAttrClusterId,
      hasLevel
    )
    const attributes = _.get(listing, transientSpecTableKey, '')

    const {
      notice,
      brandId,
      isErrorNotice
    } = getNoticeAndBrandIdForSpec(attributes, catItemId, options)

    if (isErrorNotice) {
      Toast.error(notice)
      return
    }

    if (notice) {
      Toast.warn(notice)
    }

    triggerFieldChange(brandIdConnectField, brandId)
  }

  return (
    <div>
      <FormRow
        label='商品品牌'
      >
        <Tip
          type='subTitle'
          className={styles.tip}
        >
          幫助更多用戶透過品牌找到您的商品
        </Tip>
        <div className={styles.flexContainer}>
          <div className={styles.flexItem}>
            <Field
              key='brandId'
              name={readOnly ? brandNameConnectField : brandIdConnectField}
              component={readOnly ? SingleLineText : MassiveMenuSelectField}
              data-role='product-brandId'
              options={options}
              showErrorOnActive={showErrorOnActive}
              mustShowFormError={mustShowFormError}
            />
          </div>
          <When
            value={!readOnly}
            isTrue
          >
            <div className={styles.flexItem}>
              <Button
                data-role='align-brandId-withSpecTable-button'
                className={styles.alginBrandIdButton}
                onClick={alginWithSpecTable}
              >
                同規格表品牌欄位
              </Button>
            </div>
          </When>
        </div>
      </FormRow>
    </div>
  )
}

export default BrandIDInfo
